export default __webpack_public_path__ + "static/media/712.3b5d4e63.png";